import React, { useState } from 'react';

const DemoForm = () => {
  const [formData, setFormData] = useState({ name: '', email: '', organization: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Demo request submitted:', formData);
    setSubmitted(true);
  };

  return (
    <section id="demo" className="demo-form-section">
      <h2>Request a Demo</h2>
      {submitted ? (
        <p>Thank you! We will get in touch soon.</p>
      ) : (
        <form className="demo-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="organization"
            placeholder="Organization"
            value={formData.organization}
            onChange={handleChange}
            required
          />
          <button type="submit">Submit</button>
        </form>
      )}
    </section>
  );
};

export default DemoForm;